import { Loader, LoaderSize, HorizontalFlex } from "@enxcs/dap-ui-stratos";
import { FC } from "react";

interface LoadingContentProps {
  loaderSize: LoaderSize;
  loaderHeight: string;
  loaderWidth: string;
}

const LoadingContent: FC<LoadingContentProps> = ({ loaderSize, loaderHeight, loaderWidth }) => {
  return (
    <HorizontalFlex
      data-testid="loading-content"
      $justify={"center"}
      $align={"center"}
      style={{
        height: loaderHeight,
        width: loaderWidth,
      }}
    >
      <Loader size={loaderSize} />
    </HorizontalFlex>
  );
};

export default LoadingContent;
